<template>
  <div id="page-wrapper">
    <!-- <section>
      <v-container class="text-center"> -->
    <img
      src="@/assets/sunnycloud_transparent_web.png"
      alt="Sunnycloud CRM"
      class="mx-auto mb-10"
    >

    <h2>Intresserad av kontakt?</h2>
    <v-btn color="success" @click="skickaUpp()">
      Skicka Upp
    </v-btn>
    <v-btn color="success" @click="skickaUpp(true)">
      Skicka Upp (yes)
    </v-btn>

    <v-menu
      v-model="callingcard"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <div
          id="callme"
          class="mx-auto"
          v-on="on"
        >
          <v-icon>mdi-phone</v-icon>
          Bli uppringd
        </div>
      </template>

      <v-card>
        <v-card-text>
          <v-text-field
            id="form-name"
            v-model="formdata.name"
            label="Namn *"
            class="pb-3"
            hide-details
          />
          <v-text-field
            id="form-phone"
            v-model="formdata.phone"
            label="Telefonnummer *"
            class="pb-3"
            hide-details
          />
          <v-textarea
            id="form-whyarea"
            v-model="formdata.text"
            label="Vad kan vi hjälpa er med?"
            class="pb-3"
            rows="2"
            auto-grow
            hide-details
          />
          <v-btn
            color="success"
            :disabled="!(formdata.name && formdata.phone)"
            :loading="submitting"
            @click="callMe()"
          >
            Ring mig
          </v-btn>
        </v-card-text>
      </v-card>
    </v-menu>

    <section>
      CRM & Project Management verktyg
    </section>

    <v-snackbar
      v-model="snackbar"
      bottom
      vertical
      :color="snackbarType"
      :timeout="10000"
    >
      {{ snackbarText }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Ok
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      recipient: {
        emailto: 'christoffer@sunnycloud.se',
        site: 'Sunnycloud',
      },
      formdata: {
        name: '',
        phone: '',
        text: '',
      },
      submitting: false,

      snackbarText: '',
      snackbarType: '',
      snackbar: false,
      callingcard: false,
    }
  },
  methods: {
    skickaUpp(yes) {
      console.log('skickaUpp kallad.')
      if (window.parent === window.top || yes) {
        window.parent.receiveFromIframe({
          one: 'ett',
          two: 'två',
        }, '*')
      }
    },

    async callMe() {
      this.submitting = true
      const webformDb = 'https://us-central1-sunnycloudplatform.cloudfunctions.net/vuewebform'
      const dataobject = { ...this.formdata, ...this.recipient }

      try {
        await axios.post(webformDb, dataobject)

        this.snackbarText = 'Kul att du är intresserad, vi tar kontakt inom kort'
        this.snackbarType = 'success'
        this.callingcard = false
        this.submitting = false
        this.snackbar = true
        this.formdata = {}
      } catch (error) {
        this.snackbarText = 'Hmm, nåt gick snett, försök gärna igen'
        this.snackbarType = 'error'
        this.callingcard = false
        this.submitting = false
        this.snackbar = true

        this.erroroccurred = true
        console.log('error när vill boka demo', error)
      }
    },
  },
}
</script>

<style lang='scss' scoped>

  #page-wrapper {
    height: 100%;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;

    img {
      width: 300px;
    }

    #callme {
      &, & i {
        color: #2d7ec1;
      }
      font-size: 150%;
      width: 300px;
      cursor: pointer;
      padding: 5px 10px;
      border: 1px solid transparent;
      border-radius: 5px;

      &:hover {
        border-color: #2d7ec1;
      }
    }
  }
</style>
